/* cáene temporary storefront pause. Not a server-side checkout rule.
   Recharge renewals and Shopify inventory are deliberately untouched. */
(() => {
  'use strict';
  const products = window.caeneStockWatch || [{handle: 'debloat', variants: ['56606805721468']}];
  const variants = new Map(products.flatMap(product => product.variants.map(id => [String(id), product.handle])));
  const message = 'This product is temporarily unavailable for new orders. Remove it from your cart and sign up for a stock notification instead.';
  const nativeFetch = window.fetch.bind(window);
  const blockedItem = item => variants.has(String(item?.variant_id || item?.id || '').split(':')[0]) || products.some(product => String(item?.properties?.Contents || '').toLowerCase().includes(product.handle));
  const blockedBundle = value => {
    if (!value) return false;
    try {
      const bytes = Uint8Array.from(atob(value), char => char.charCodeAt(0));
      const view = new DataView(bytes.buffer);
      const count = view.getUint32(12);
      if (count > 100 || bytes.length < 16 + count * 36) return false;
      for (let i = 0; i < count; i++) if (variants.has(String(view.getBigUint64(32 + i * 36)))) return true;
    } catch (_) { /* not a Recharge selection blob */ }
    return false;
  };
  const parseBody = body => {
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { return Object.fromEntries(new URLSearchParams(body)); }
    }
    if (body instanceof FormData || body instanceof URLSearchParams) return Object.fromEntries(body);
    return body || {};
  };
  window.fetch = async (input, options = {}) => {
    const url = new URL(typeof input === 'string' ? input : input.url, location.href);
    const body = parseBody(options.body);
    const cartAdd = url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname);
    if ((cartAdd && (body.items || [body]).some(blockedItem)) || ((/rechargeapps\.com$/.test(url.hostname) || url.pathname === '/tools/recurring/bundling-storefront-manager/api/v1/bundles') && blockedBundle(body.bundle))) {
      window.alert(message);
      return new Response(JSON.stringify({status:422,message,description:message}), {status:422,headers:{'Content-Type':'application/json'}});
    }
    return nativeFetch(input, options);
  };
  const watchURL = variant => '/products/' + variants.get(String(variant));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-add], [data-story-product-variant]');
    const variant = button && String(button.dataset.variantId || button.dataset.storyProductVariant);
    if (button && variants.has(variant)) {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(watchURL(variant));
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const variant = String(new FormData(form).get('id'));
    if (!variants.has(variant)) return;
    event.preventDefault(); event.stopImmediatePropagation(); location.assign(watchURL(variant));
  }, true);
  const sync = () => {
    for (const [variant, handle] of variants) document.querySelectorAll(`[data-cart-add][data-variant-id="${variant}"]`).forEach(button => {
      if (button.textContent !== 'NOTIFY ME') button.textContent = 'NOTIFY ME';
      button.setAttribute('aria-label', `Notify me when ${handle} is back`);
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    sync();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    }).observe(document.body,{childList:true,subtree:true});
  });
})();
